export const LAB_FINDING_QUESTIONS = {
  a1c: {
    date: "",
    description: "",
    label: "A1C",
    order: 3,
  },
  cbc: {
    date: "",
    description: "",
    label: "CBC",
    order: 1,
  },
  cmp: {
    date: "",
    description: "",
    label: "CMP",
    order: 2,
  },
  flp: {
    date: "",
    description: "",
    label: "FLP",
    order: 4,
  },
  med_levels: {
    date: "",
    description: "",
    label: "Med Levels",
    order: 8,
  },
  toxicology: {
    date: "",
    description: "",
    label: "Toxicology",
    order: 7,
  },
  tsh: {
    date: "",
    description: "",
    label: "TSH",
    order: 5,
  },
  urinalysis: {
    date: "",
    description: "",
    label: "Urinalysis",
    order: 6,
  },
};
